import { Moon, Sun, SunMoon } from 'lucide-react';
import { ToolbarToggleGroup, type ToolbarToggleOption } from './ToolbarToggleGroup';
import type { CanvasThemeChoice } from './canvasPalette';

const OPTIONS: ToolbarToggleOption<CanvasThemeChoice>[] = [
  {
    value: 'app',
    label: <SunMoon size={12} />,
    ariaLabel: 'Canvas like the app',
    title: 'Draw the canvas light or dark, like the rest of the app',
    testId: 'canvas-theme-app',
  },
  {
    value: 'light',
    label: <Sun size={12} />,
    ariaLabel: 'Light canvas',
    title: 'Always draw the canvas light',
    testId: 'canvas-theme-light',
  },
  {
    value: 'dark',
    label: <Moon size={12} />,
    ariaLabel: 'Dark canvas',
    title: 'Always draw the canvas dark',
    testId: 'canvas-theme-dark',
  },
];

interface CanvasThemeToggleProps {
  choice: CanvasThemeChoice;
  onChange: (choice: CanvasThemeChoice) => void;
}

/** Whether the floor-plan canvas is drawn light, dark, or like the app. */
export function CanvasThemeToggle({ choice, onChange }: CanvasThemeToggleProps) {
  return (
    <ToolbarToggleGroup
      ariaLabel="Canvas colours"
      data-testid="canvas-theme-toggle"
      options={OPTIONS}
      value={choice}
      onChange={onChange}
    />
  );
}
